import { createContext, useEffect, useState } from "react";
import { useContext } from "react";
import { auth } from "../firebase/firebaseConfig"
import { db } from "../firebase/firebaseConfig";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  updateProfile

} from "firebase/auth"
import { addDoc, collection, onSnapshot, doc, setDoc } from "firebase/firestore"
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase/firebaseConfig";

const AuthContext = createContext();

export function useAuthUser() {
  return useContext(AuthContext)
}

export function UserAuthProvider({ children }) {
  const [liveUser, setLiveUser] = useState({})
  const [dbUser, setDbUser] = useState([])
  const [load, setLoad] = useState(true)
  const [online, setOnline] = useState(true)
  const [curentId, setCurrentId] = useState({})
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    const name = dbUser.filter((item) => {
      if (liveUser?.uid === item?.uid) {
        return item
      }
    })
    setCurrentId(...name)
  }, [dbUser, liveUser, liveUser?.uid])

  useEffect(() => {
    setOnline(curentId?.online)

  }, [curentId?.online])


  useEffect(() => {
    const online = () => {
      setOnline(true)
    }
    const offline = () => {
      setOnline(false)
    }
    window.addEventListener("online", online)
    window.addEventListener('offline', offline)
    return () => {
      window.removeEventListener("online", online)
      window.removeEventListener("offline", offline)
    }

  }, [])

  //storage funciton
  async function upload(file, liveuser, setLoad) {
    const fileRef = ref(storage, liveuser.uid)
    setLoad(true)
    await uploadBytes(fileRef, file)
    const photourl = await getDownloadURL(fileRef)

    if (photourl !== '') {
      updateProfile(liveuser, { photoURL: photourl })
      setDoc(doc(db, "users", curentId?.id), {
        photoURL: photourl
      }, { merge: true })
    } else {
      console.log("somting wrong")
    }
    setLoad(false)
    toast.success("Image uploaded sucessfully")
  }


  async function SignUp(name, email, password) {
    setLoading(true)
    await createUserWithEmailAndPassword(auth, email, password)
      .then((res) => {
        console.log(res);
        const docRef = collection(db, "users")
        setLoading(false)
        addDoc(docRef, {
          name: name,
          email: res.user.email,
          uid: res.user.uid,
          photoURL: res.user.photoURL,
          createdAt: Date.now(),
        })
      }).catch(() => {
        setLoading(false)
      })

  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password)
  }


  async function LogOut() {
    await signOut(auth);

  }



  useEffect(() => {
    const res = onAuthStateChanged(auth, (CurrentUser) => {
      setLiveUser(CurrentUser)
    })
    return () => {
      res()

    }
  }, [])

  useEffect(() => {
    const colRef = collection(db, "users")

    onSnapshot(colRef, (snapsshot) => {
      const getUser = []
      setLoad(true)
      snapsshot.docs.forEach((item) => {
        getUser.push({ ...item.data(), id: item.id })
      });
      setDbUser(getUser)
      setLoad(false)
    })
  }, [load])

  const value = {
    SignUp,
    online,
    login,
    liveUser,
    dbUser,
    LogOut,
    load,
    upload,
    loading
  }
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}